export function registerSW(config = {}) {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    registerServiceWorker(swUrl, config);
  });
}

function registerServiceWorker(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Service Worker registered:", registration);

      handleUpdates(registration, config);
      handleControllerChange();
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

function handleUpdates(registration, config) {
  registration.addEventListener("updatefound", () => {
    const newWorker = registration.installing;
    if (!newWorker) {
      return;
    }

    newWorker.addEventListener("statechange", () => {
      handleWorkerStateChange(newWorker, registration, config);
    });
  });
}

function handleWorkerStateChange(worker, registration, config) {
  if (worker.state !== "installed") {
    return;
  }

  if (navigator.serviceWorker.controller) {
    console.log("New update available!");
    if (typeof config.onUpdate === "function") {
      config.onUpdate(registration);
    }
  } else {
    console.log("App is ready for offline use.");
  }
}

function handleControllerChange() {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    console.log("Controller changed. Reloading the page...");
    window.location.reload();
  });
}
